import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart from "./Cart";

const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debounceTimerId, setDebounceTimerId] = useState(0);
  const [items, setItems] = useState([]);
  const [token, setToken] = useState(null);

  const resToken = localStorage.getItem("token");

  useEffect(()=>{
    resToken?.length ? setToken(resToken) : setToken(null)
  }, [resToken])


  const performAPICall = async () => {
    try {
      setLoading(true);
      let url = `${config.endpoint}/products`;
      if (searchTerm !== "") {
        url = `${config.endpoint}/products/search?value=${searchTerm}`;
      }
      let response = await axios.get(url);
      let productData = response.data;
      let data = [...productData];
      setProducts(data);
      setLoading(false);
    } catch (error) {
      setProducts([]);
      setLoading(false);
      console.log("Error found in performApiCall_product.js", error);
    }
  };

  const _fetchCart = async () => {
    try {
      if(!resToken) return;
      let url = `${config.endpoint}/cart`;
      let response = await axios.get(url, {
        headers : { Authorization: `Bearer ${resToken}` ,},
      }); 
      let data = response.data;
      if(data?.length){
        setItems(data);
      }
    } catch (error) {
      console.log("Error found in _fetchCart", error);
    }
  };
  
  const _postItemsToCart = async (payload) => {
    try {
      setCartLoading(true);
      let url = `${config.endpoint}/cart`;
      let response = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${resToken}` },
      });
      setItems(response.data);
      setCartLoading(false);

    } catch (error) {
      setCartLoading(false);

      console.log(error);
    }
  };

  const _handleAddToCart = async (payload, isFromAddToCart=false) => {
    if(!token) return;
    
    if(isFromAddToCart && payload.qty === 1){
      if(items.findIndex(item => item.productId === payload.productId) !== -1){
       return enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.", { variant: "warning" });
      }
    }
    _postItemsToCart(payload);

  };

  useEffect(() => {
    performAPICall();
    _fetchCart();
  }, []);

  useEffect(() => {
    if (debounceTimerId !== 0) {
      clearTimeout(debounceTimerId);
    }
    const newTimerId = setTimeout(() => {
      performAPICall();
    }, 500);

    setDebounceTimerId(newTimerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const _searchValue = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div>
      <Header>
        <Box mb={2} mt={2}>
          <TextField
            size="medium"
            type="text"
            name="search-box"
            className="search-desktop searchBox"
            placeholder="Search for items/categories"
            InputProps={{
              endAdornment: <SearchIcon />,
            }}
            value={searchTerm}
            onChange={(e) => _searchValue(e)}
          />
        </Box>
      </Header>

      <Box mb={2} mt={2} className="imgContainer">
        <TextField
          size="medium"
          type="text"
          name="search-box"
          className="search-mobile mobileSearchbox "
          placeholder="Search for items/categories"
          value={searchTerm}
          onChange={(e) => _searchValue(e)}
          InputProps={{
            endAdornment: <SearchIcon />,
          }}
        />
      </Box>

      <div className="main_container">
        <Grid container spacing={2} mb={2}>
          <Grid item className="product-grid">
            <Box className="hero">
              <p className="hero-heading">
                India's <span className="hero-highlight">FASTEST DELIVERY</span>
                to your door step
              </p>
            </Box>
          </Grid>

          {products.length ? (
            products.map((product) => {
              return (
                <Grid item key={product._id} xs={6} md={3}>
                  <ProductCard
                    product={product}
                    handleAddToCart={_handleAddToCart}
                  />
                </Grid>
              );
            })
          ) : loading ? (
            <div className="loading">
              <CircularProgress size="40px" />
              <p> Loading products…</p>
            </div>
          ) : (
            <Box className="loading">
              <SentimentDissatisfied />
              <p> No Products Found </p>
            </Box>
          )}
        </Grid>

        {token ? (
          <Cart
            products={products}
            items={items}
            handleQuantity={_handleAddToCart}
            cartLoading={cartLoading}
          />
        ) : null }
      </div>

      <Footer />
    </div>
  );
};

export default Products;
